<app-table [data]="equipment"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [rowExpand]="false"
           [rowDuplicate]="true"
           [isMaterial]="false"
           [hasTitle]="hasTitle"
           [headerBackgroundColor]="headerBackgroundColor"
           title="{{'admin.equipment.table.title' | translate}}"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)"
           (duplicateClick)="onDuplicate($event)"
           (rowClick)="onRowClick($event)">
    <app-table-column header="{{'admin.equipment.table.columns.id' | translate}}"
                      field="id">
    </app-table-column>
    <app-table-column header="{{'admin.equipment.table.columns.name' | translate}}"
                      filterPlaceholder="{{'admin.equipment.table.filter.placeholder.name' | translate}}"
                      filter="true"
                      sortable="true"
                      field="name">
    </app-table-column>
    <app-table-column header="{{'admin.equipment.table.columns.line' | translate}}"
                      filterPlaceholder="{{'admin.equipment.table.filter.placeholder.line' | translate}}"
                      filter="true"
                      sortable="true"
                      field="line">
        <ng-template #body
                     let-equipment="rowData">
            <span>{{ equipment.line.name }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.equipment.table.columns.MESId' | translate}}"
                      filterPlaceholder="{{'admin.equipment.table.filter.placeholder.MESId' | translate}}"
                      filter="true"
                      sortable="true"
                      field="MESId">
    </app-table-column>
</app-table>
